import * as React from 'react';
import { Link } from 'react-router-dom';
import { UitkHeading } from 'uitk-react-text';

export interface RoomComponentPackageMobileProps {
  roomCount: any;
  childComponent: any;
}
export class RoomComponentPackageMobile extends React.Component<RoomComponentPackageMobileProps, any> {
  public constructor(props) {
    super(props);
  }

  public render() {
    const { roomCount } = this.props;

    return (
      <>
        <div className="uitk-cell">{this.props.childComponent}</div>
      </>
    );
  }
}
